/**
 * @generated SignedSource<<bf5224a7b348c342f0d034f7a96dc912>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AssociationType = "MANDATORY" | "OPTIONAL";
export type HealthInformationStatus = "NONE" | "SOME" | "UNKNOWN";
import { FragmentRefs } from "relay-runtime";
export type PatientConditionInformationOutputFragment$data = {
  readonly conditions: ReadonlyArray<{
    readonly comment: string | null;
    readonly icdDiagnosis: {
      readonly associationType: AssociationType | null;
      readonly diagnosisCode: string;
      readonly id: string;
      readonly isAssociation: boolean;
      readonly primaryCode: string | null;
      readonly secondaryCode: string | null;
      readonly text: string;
    };
  }>;
  readonly id: string;
  readonly status: HealthInformationStatus;
  readonly " $fragmentType": "PatientConditionInformationOutputFragment";
};
export type PatientConditionInformationOutputFragment$key = {
  readonly " $data"?: PatientConditionInformationOutputFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PatientConditionInformationOutputFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PatientConditionInformationOutputFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ConditionOutput",
      "kind": "LinkedField",
      "name": "conditions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "comment",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "IcdDiagnosis",
          "kind": "LinkedField",
          "name": "icdDiagnosis",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAssociation",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "diagnosisCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "primaryCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "secondaryCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "associationType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PatientConditionInformationOutput",
  "abstractKey": null
};
})();

(node as any).hash = "24a5876dac4ce78030fbe8ac5599480f";

export default node;
